export default __webpack_public_path__ + "addfd14c1ade6732a89f730ff879f7e6.png";